const isObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const getString = (value) => (typeof value === "string" ? value.trim() : "");

export const paymentFlowTypes = {
  REDIRECT: "redirect",
  WIDGET: "widget",
  ERROR: "error",
};

export const resolvePaymentFlow = (payload) => {
  if (!isObject(payload)) {
    return {
      type: paymentFlowTypes.ERROR,
      reason: "Некорректный ответ сервера при оплате",
    };
  }

  const acquiring = getString(payload.acquiring);
  const payUrl = getString(payload.pay_url);
  const terminalKey = getString(payload.terminal_key);

  if (acquiring === "VTB_BANK") {
    if (!payUrl) {
      return {
        type: paymentFlowTypes.ERROR,
        reason: "Платежная ссылка недоступна, попробуйте позже",
      };
    }
    return {
      type: paymentFlowTypes.REDIRECT,
      payUrl,
    };
  }

  if (acquiring === "T_BANK") {
    if (!terminalKey) {
      return {
        type: paymentFlowTypes.ERROR,
        reason: "Параметры оплаты недоступны, попробуйте позже",
      };
    }
    return {
      type: paymentFlowTypes.WIDGET,
      values: payload,
    };
  }

  // Legacy response can be returned without acquiring field.
  return {
    type: paymentFlowTypes.WIDGET,
    values: payload,
  };
};

export default resolvePaymentFlow;
